/**
 * @owner @Appboy/clip
 */

import { requestElevatedAccess } from "./requestElevatedAccess";

/* A wrapper around `requestElevatedAccess` that returns a JQuery Deferred instead of a Promise. */
export const requestElevatedAccessDeferred: () => JQuery.Deferred<boolean> = () => {
  const deferred = $.Deferred();
  requestElevatedAccess()
    .then((result) => {
      if (result) {
        deferred.resolve(true);
      } else {
        deferred.reject();
      }
    })
    .catch(() => deferred.reject());
  return deferred;
};
